import { Box, Tooltip, useTheme } from "@mui/material";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { Q3DButton } from "../../Parts/Q3DButton";
import HelmContext from "../Contexts/HelmContext";
import axios from "axios";
import { Common } from "../../../../common/src";
import {
  ProjectDetailContext,
  UseSnackbarContext,
} from "../../../pages/ProjectDetail";
import { config } from "../../../config/config";
import { ECoordinateTransformMode } from "../../config/componentsConfig";

type Props = {};

export const HelmVerification = (props: Props) => {
  useState<boolean>(false); // while Fetch
  const { projectDetail, viewer } = useContext(ProjectDetailContext);
  const { verificationPoints, autoMapCoordinate, handleSave } =
    useContext(HelmContext);
  const theme = useTheme();

  const { openSuccess, openError } = useContext(UseSnackbarContext);
  const [whileLoading, setWhileLoading] = useState(false);
  const [abortController, setAbortController] = useState<AbortController>(
    new AbortController()
  );

  useEffect(() => {
    setAbortController(new AbortController());
  }, []);

  const downloadProjectData = async (input: Common.ProjectDownloadAllInput) => {
    return new Promise<void>((resolve, reject) => {
      const params = {
        ...input,
        snapshot: input.verificationPoints
          ? viewer.getCanvas().toDataURL("image/jpeg")
          : "",
      };
      axios
        .post(
          `${config.serverHost}/api/v1/project/${projectDetail.id}/download`,
          params,
          {
            withCredentials: true,
            responseType: "blob",
            signal: abortController.signal,
          }
        )
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const a = document.createElement("a");
          a.href = url;

          const contentDisposition = res.headers["content-disposition"];
          const regex = /filename=(.+)/;
          const match = contentDisposition?.match(regex);
          if (match) {
            a.download = decodeURIComponent(match[1].trim());
          } else {
            a.download = "noname";
          }

          a.click();
          // ダウンロード後は不要なのでaタグを除去
          a.remove();
          resolve();
        })
        .catch((err) => {
          if (err.message !== "canceled") {
            openError(t("DOWNLOAD_ERROR"));
            reject();
          }
        });
    });
  };

  // const handleDownloadCancel = async () => {
  //   if (whileLoading) {
  //     openSuccess(t("CANCELLED"));
  //     abortController.abort();
  //   }
  //   setWhileLoading(false);
  // };

  const handleDownloadOK = async () => {
    setWhileLoading(true);
    for (let i = 0; i < verificationPoints.length; i++) {
      if (verificationPoints[i].id === "new") {
        await handleSave(
          ECoordinateTransformMode.VERIFICATION,
          verificationPoints[i].id
        );
      }
    }
    let input: Common.ProjectDownloadAllInput = {
      verificationPoints: true,
    };

    await uploadSnapshot();
    await downloadProjectData(input)
      .then(() => {
        setWhileLoading(false);
        openSuccess(t("DOWNLOAD_COMPLETED"));
      })
      .catch(() => {
        setWhileLoading(false);
      });
  };

  const uploadSnapshot = async () => {
    const body = {
      snapshot: viewer.getCanvas().toDataURL("image/jpeg"),
    } as Common.VerifiedPointUpdateBody;

    await axios
      .put(
        `${config.serverHost}/api/v1/project/${projectDetail?.id}/points/verified/file`,
        body,
        { withCredentials: true }
      )
      .then(() => {})
      .catch((err) => {
        setWhileLoading(false);
        openError(t("DOWNLOAD_ERROR"));
        throw err;
      })
      .finally(() => {});
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Tooltip
          title={
            <span className="tool-tip-cal">
              {t("VALID_POINT_ACCURACY_CHECK")}
            </span>
          }
          placement="top"
          arrow
        >
          <span>
            <Q3DButton
              text={t("VALID_POINT_ACCURACY_CHECK")}
              onClick={() => {
                autoMapCoordinate(projectDetail?.id);
              }}
              disabled={
                !verificationPoints.some(
                  (value) => !(value.x === 0 && value.y === 0 && value.z === 0)
                )
              }
              height={"36px"}
              sx={{
                background: theme.palette.base.ymdBackground,
                color: "#FFFFFF",
                "&:hover": {
                  background: "#736CED",
                },
              }}
            />
          </span>
        </Tooltip>
        <span style={{ margin: "0 5px" }}>
          <Q3DButton
            text={t("ACCURACY_VALIDATION_EXPORT")}
            loading={whileLoading}
            onClick={async () => {
              handleDownloadOK();
            }}
            disabled={
              !verificationPoints.some(
                (value) => !(value.x === 0 && value.y === 0 && value.z === 0)
              )
            }
            height={"36px"}
            sx={{
              background: theme.palette.base.ymdBackground,
              color: "#FFFFFF",
              "&:hover": {
                background: "#736CED",
              },
            }}
          />
        </span>
        {/* <Q3DHintPopover
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          content={t("VERIFY_HINT")}
        /> */}
      </Box>
    </>
  );
};
